module.exports = __webpack_public_path__ + "static/media/landscape3.90be3a3c.jpg";